import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Modal from '../Modal/Modal';
import KioskOrderFormContainer from './KioskOrderFormContainer';
import {hideModal} from '../../reducers/modalReducer';


class KioskOrderFormModal extends Component {
  render() {
    const {onClose, onSubmit, isPaymentKiosk} = this.props;
    const modalStyle = isPaymentKiosk ? {top:'28%', width: '90%', maxWidth:'90%'} : {}
    return (
      <Modal
        scrollable={true}
        paddingTop="65px"
        overlayTop={0}
        closeOnOutsideClick={false}
        isOpened
        onClose={onClose}
        style={modalStyle}
      >
        <KioskOrderFormContainer
          onClose={onClose}
          onSubmit={onSubmit}
        />
      </Modal>
    );
  }
}

KioskOrderFormModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch, props) => ({
  onClose: () => props.onClose(),
  onSubmit: (formData) => props.onSubmit(formData)
});

export default connect(null, mapDispatchToProps)(KioskOrderFormModal);



// WEBPACK FOOTER //
// ./src/components/KioskOrderModal/KioskOrderFormModal.jsx